module.exports = __webpack_public_path__ + "media/icon/icon-download-2-1ce2beef.svg";